import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import {
  collection,
  getDocs,
  updateDoc,
  doc,
  query,
  where,
} from "firebase/firestore";

// Simple drag-and-drop for content reordering
export default function DragDropContentManager({ deity }) {
  const [contents, setContents] = useState([]);

  useEffect(() => {
    if (deity) {
      getDocs(
        query(collection(db, "contents"), where("deityId", "==", deity.id))
      ).then((snapshot) => {
        // Add 'order' field if missing, sort by it
        const docs = snapshot.docs.map((doc, idx) => {
          const data = doc.data();
          return {
            id: doc.id,
            ...data,
            order: data.order !== undefined ? data.order : idx
          };
        });
        docs.sort((a, b) => a.order - b.order);
        setContents(docs);
      });
    }
  }, [deity]);

  // Drag-and-drop handlers
  const onDragStart = (idx) => (e) => {
    e.dataTransfer.setData("dragIndex", idx);
  };

  const onDrop = (idx) => async (e) => {
    const fromIdx = Number(e.dataTransfer.getData("dragIndex"));
    if (fromIdx === idx) return;
    const reordered = [...contents];
    const [moved] = reordered.splice(fromIdx, 1);
    reordered.splice(idx, 0, moved);
    setContents(reordered);

    // Update Firestore order field
    for (let i = 0; i < reordered.length; i++) {
      await updateDoc(doc(db, "contents", reordered[i].id), { order: i });
    }
  };

  return (
    <div style={{ maxWidth: 700, margin: "0 auto", padding: 16 }}>
      <h2>
        Drag & Drop Reorder: {deity.nameEn} ({deity.nameTa})
      </h2>
      <ul style={{ listStyle: "none", padding: 0 }}>
        {contents.map((content, idx) => (
          <li
            key={content.id}
            draggable
            onDragStart={onDragStart(idx)}
            onDragOver={e => e.preventDefault()}
            onDrop={onDrop(idx)}
            style={{
              padding: "12px 16px",
              marginBottom: 8,
              background: "#fff",
              border: "1px solid #ddd",
              borderRadius: 6,
              cursor: "grab",
              boxShadow: "0 2px 4px #0001"
            }}
          >
            <strong>{content.titleEn}</strong> ({content.type})<br />
            <span style={{ fontSize: 13, color: "#888" }}>{content.artist}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}